import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import * as v from 'valibot'

import track from '@/core/utils/tracking/track'
import { LearnpathsSummaryDetailsTabPanel } from '@/learnpaths-summary/components/LearnpathsSummaryDetailsTabPanel/LearnpathsSummaryDetailsTabPanel'
import LearnpathsSummaryDetailsTabsProgress from '@/learnpaths-summary/components/LearnpathsSummaryDetailsTabsProgress/LearnpathsSummaryDetailsTabsProgress'

const searchSchema = v.object({
  learner: v.fallback(v.optional(v.string()), undefined),
  progress: v.fallback(
    v.optional(v.array(v.picklist(['not-started', 'started', 'completed']))),
    undefined,
  ),
})

export const Route = createFileRoute(
  '/company/_management/learnpaths/overview/$learnpathId/progress',
)({
  validateSearch: searchSchema,
  component: ProgressTab,
})

function ProgressTab() {
  const { learnpathId } = Route.useParams()

  useEffect(() => {
    track('LP learners progress tab viewed', { learnpath_id: learnpathId })
  }, [learnpathId])

  return (
    <LearnpathsSummaryDetailsTabPanel>
      <LearnpathsSummaryDetailsTabsProgress />
    </LearnpathsSummaryDetailsTabPanel>
  )
}
